// Container sizes should be based on the top level app container
// using the window can break sizing in the MFE since the size of the
// container is smaller than the full window

export const getContainerWidth = () => {
  const container = document.querySelector(".appContainer");
  return container ? container.clientWidth : window.innerWidth;
};

export const getContainerHeight = () => {
  const container = document.querySelector(".appContainer");
  return container ? container.clientHeight : window.innerHeight;
};

export const getContainerOffset = () => {
  const container = document.querySelector(".appContainer");
  if (!container) return { left: 0, top: 0 };
  const rect = container.getBoundingClientRect();
  return { left: rect.left, top: rect.top };
};
